export const secretTabs = [
  { label: "Release", slug: "release" },
  { label: "AWS", slug: "aws" },
  { label: "GCP", slug: "gcp" },
] as const;

export type SecretTabItem = (typeof secretTabs)[number]["slug"];
